import React, { useState } from 'react';
import { useField } from 'formik';
import { Eye, EyeOff } from 'lucide-react';

interface ChedaGamingPasswordInputProps {
  name: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  icon?: React.ReactNode;
  className?: string;
  normalize?: (value: string) => string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  value?: any;
  error?: string | undefined;
  touched?: boolean;
}

const ChedaGamingPasswordInput: React.FC<ChedaGamingPasswordInputProps> = ({
  name,
  label,
  placeholder,
  required = false,
  disabled = false,
  icon,
  className,
  normalize,
  onChange,
  onBlur,
  value,
  error,
  touched,
}) => {
  const [field, meta, helpers] = useField(name);
  const [show, setShow] = useState<boolean>(false);

  const handleLocalChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    const newVal = normalize ? normalize(val) : val;
    helpers.setValue(newVal);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(e);
    }
    handleLocalChange(e);
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    if (onBlur) {
      onBlur(e);
    }
    field.onBlur(e);
  };

  const inputValue = value !== undefined ? value : field.value;
  const showError = (touched ?? meta.touched) && (error ?? meta.error);

  return (
    <div className={`form-group ${className || ''}`}>
      {label && <label className="form-label">{label}</label>}
      <div className="input-container">
        {icon}
        <input
          {...field}
          type={show ? 'text' : 'password'}
          placeholder={placeholder}
          onChange={handleChange}
          onBlur={handleBlur}
          value={inputValue}
          required={required}
          disabled={disabled}
          className="form-input"
        />
        <button
          type="button"
          className="password-toggle"
          onClick={() => setShow(!show)}
          disabled={disabled}
          aria-label={show ? 'Hide password' : 'Show password'}
        >
          {show ? <EyeOff size={18} /> : <Eye size={18} />}
        </button>
      </div>
      {showError && <div className="input-error">{(error ?? meta.error) as string}</div>}
    </div>
  );
};

export default ChedaGamingPasswordInput;
